"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssApplicationName = exports.FEProcessGuid = exports.FEProcessName = exports.applicationName = exports.internalCall = exports.stepItgURI = exports.startItgURI = exports.ItgURL = void 0;
exports.ItgURL = 'https://maestro-nxgen-uat-vip.cable.comcast.com';
exports.startItgURI = '/itg-execution/ITGProcess';
exports.stepItgURI = '/itg-execution/ITGStep';
exports.internalCall = false;
exports.applicationName = 'Einstein360';
exports.FEProcessName = 'Test_RefundsAndRefundCheck';
exports.FEProcessGuid = '0d103942-99ef-4929-8da8-33ddd4a41fe1';
exports.cssApplicationName = 'FESDK';
//# sourceMappingURL=itgConfig.model.js.map